module.exports = __webpack_public_path__ + "media/images/edit-avatar-button-c6c356efe67cff3818425f6db4e3c444.svg";